import { render, staticRenderFns } from "./refund-dialog.vue?vue&type=template&id=610eaa5a&scoped=true"
import script from "./refund-dialog.vue?vue&type=script&lang=js"
export * from "./refund-dialog.vue?vue&type=script&lang=js"
import style0 from "./refund-dialog.vue?vue&type=style&index=0&id=610eaa5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610eaa5a",
  null
  
)

export default component.exports